import { ButtonSelectItemComponent } from './../button-select-item/button-select-item.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Component, forwardRef, ContentChildren, QueryList, AfterContentInit, OnDestroy } from '@angular/core';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-button-select',
  templateUrl: './button-select.component.html',
  styleUrls: ['./button-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ButtonSelectComponent),
    multi: true
  }]
})
export class ButtonSelectComponent implements ControlValueAccessor, AfterContentInit, OnDestroy {

  value: any;
  onChange: (_: any) => void = (_: any) => {
    // This is intentional
  }
  onTouched: () => void = () => {
    // This is intentional
  }

  isAlive = true;

  @ContentChildren(ButtonSelectItemComponent) contentChildren!: QueryList<ButtonSelectItemComponent>;

  ngAfterContentInit() {
    this.contentChildren
      .forEach(c => c.onSelect.pipe(takeWhile(() => this.isAlive)).subscribe(value => this.writeValue(value)));
    this.updateChildren();
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  updateChanges() {
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    this.value = value;

    this.updateChildren();

    this.updateChanges();
    this.onTouched();
  }

  private updateChildren() {
    if (this.contentChildren) {
      this.childrenSetValue(this.value);
    }
  }

  private childrenSetValue(value) {
    this.contentChildren.filter(c => c.value !== value)
      .forEach(c => c.isSelected = false);
    this.contentChildren.filter(c => c.value === value)
      .forEach(c => c.isSelected = true);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
